import React, { ReactNode } from 'react';
import Select, { SelectProps } from '../Select';
import { createAntField } from '../CreateAntField';
import { Field } from 'react-final-form';

// @ts-ignore
const FormSelectWrapper = createAntField<SelectProps>(Select);

export interface FormInputProps extends SelectProps<any> {
  name: string;
  label?: ReactNode;
  options: FormSelectOptions;
  required?: boolean;
}

export type FormSelectOption = {
  name: React.ReactNode;
  value: string | number;
};
export type FormSelectOptions = FormSelectOption[];

const FormSelect = ({ options, ...props }: FormInputProps) => {
  return (
    <Field {...props} component={FormSelectWrapper} selectOptions={options} />
  );
};

export default FormSelect;
